module.exports = __webpack_public_path__ + "img/atlaf-xnz27.73b72b9e.png";